import { ExtendedFamily } from "../../../SubjectData/BasicWords/Family.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";

export default function ExtendedFamilyDeck() {

 return (
    <>
      <HeaderNav GoBack_to="/FamilyNav" />
      <FlashcardInterface deckData={ExtendedFamily} title="Extended Family" />
    </>
)}